import React from "react";

import TripVerificationList from "../components/trips/trip-verification-list";

const TripVerification = () => {
  return <TripVerificationList/>;
};

export default TripVerification;
